module.exports = __webpack_public_path__ + "img/slogn.2f4d3b1d.png";